import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentPropsWithRef } from 'react'
import s from './Chip.module.css'

/**
 * Chip d'équipe — le `.team-chip` du prototype : un point coloré, un libellé, une
 * teinte par équipe. La teinte pilote la couleur du texte, le point (qu'elle colore par
 * `currentcolor`) **et** le fond (dérivé par `color-mix`), via la variable locale `--tc`
 * du module CSS.
 */
const chip = cva(s.root, {
  variants: {
    tone: {
      blue: s.toneBlue,
      amber: s.toneAmber,
      green: s.toneGreen,
    },
    /** Le libellé passe à la ligne et la pastille grandit, dans une colonne étroite. */
    wrap: { true: s.wrap },
  },
  defaultVariants: { tone: 'blue' },
})

export type ChipProps = ComponentPropsWithRef<'span'> & VariantProps<typeof chip>
export type ChipTone = NonNullable<VariantProps<typeof chip>['tone']>

export function Chip({ tone, wrap, className, ...props }: ChipProps) {
  return <span className={chip({ tone, wrap, className })} {...props} />
}
